import { render } from "./ProductsLive.vue?vue&type=template&id=a3502ecc&scoped=true"
import script from "./ProductsLive.vue?vue&type=script&lang=js"
export * from "./ProductsLive.vue?vue&type=script&lang=js"

import "./ProductsLive.vue?vue&type=style&index=0&id=a3502ecc&lang=scss&scoped=true"
import "./ProductsLive.vue?vue&type=style&index=1&id=a3502ecc&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3502ecc"]])

export default __exports__